import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import ButtonCompo from "../../component/ButtonCompo";
import DialogBox from "../../component/DialogBox";
import SelectField from "../../component/SelectField";
import RadioCompo from "../../component/RadioCompo";
import SwitchCompo from "../../component/SwitchCompo";

function AdminAccessManagement({
  userId,
  setReload,
  setLoading,
  setOpen,
  setSuccess,
  setMessage,
}) {
  //states for handling roles
  const [onBoardingAccess, setOnBoardingAccess] = useState(false);
  const [leaveApproval, setLeaveApproval] = useState(false);
  const [letterGenerate, setLetterGenerate] = useState(false);
  const [projectAssign, setProjectAssign] = useState(false);
  const [employeeRecordAccess, setEmployeeRecordAccess] = useState(false);
  const [employeeEditBoarding, setEmployeeEditBoarding] = useState(false);
  const [companyManagement, setCompanyManagement] = useState(false);
  const [salaryStructureCreation, setSalaryStructureCreation] = useState(false);
  const [payslipEditGenerate, setPayslipEditGenerate] = useState(false);
  const [leaveManagement, setLeaveManagement] = useState(false);
  const [notificationSend, setNotificationSend] = useState(false);
  const [eventManagement, setEventManagement] = useState(false);
  const [equipmentManagement, setEquipmentManagement] = useState(false);
  const [employeeDetailsView, setEmployeeDetailsView] = useState(false);
  const [employeeManagement, setEmployeeManagement] = useState(false);
  const [goalManagement, setGoalManagement] = useState(false);
  const [policyManagement, setPolicyManagement] = useState(false);
  const [housekeepingStaffManagement, setHousekeepingStaffManagement] =
    useState(false);
  const [talentAquisation, setTalentAquisation] = useState(false);
  const [hiringReq, setHiringReq] = useState(false);

  // other states
  const [selectedRole, setSelectedRole] = useState("custom");

  //add to admin
  async function addAdmin() {
    if (selectedRole?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select a role for admin");
      return null;
    }
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/admin/add`,
        method: "post",
        withCredentials: true,
        data: {
          role: selectedRole,
          userId: userId,
          onBoardingAccess,
          leaveApproval,
          letterGenerate,
          projectAssign,
          employeeRecordAccess,
          employeeEditBoarding,
          companyManagement,
          salaryStructureCreation,
          payslipEditGenerate,
          leaveManagement,
          notificationSend,
          eventManagement,
          equipmentManagement,
          employeeDetailsView,
          housekeepingStaffManagement,
          employeeManagement,
          goalManagement,
          policyManagement,
          talentAquisation,
          hiringReq,
        },
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Admin added successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // value array of role of select field
  const roleArray = [
    {
      title: "Manager",
      value: "manager",
    },
    {
      title: "HR",
      value: "headHr",
    },
    {
      title: "HR Recruiter",
      value: "hrRecruiter",
    },
    {
      title: "Facility Team",
      value: "facilityTeam",
    },
    {
      title: "IT Helpdesk (System Admin)",
      value: "itHelpDesk",
    },
    {
      title: "Custom",
      value: "custom",
    },
  ];

  //set default values
  useEffect(() => {
    if (selectedRole === "headHr") {
      setOnBoardingAccess(true);
      setLetterGenerate(true);
      setProjectAssign(true);
      setEmployeeRecordAccess(true);
      setEmployeeEditBoarding(true);
      setCompanyManagement(true);
      setSalaryStructureCreation(true);
      setPayslipEditGenerate(true);
      setLeaveManagement(true);
      setNotificationSend(true);
      setEventManagement(true);
      setGoalManagement(true);
      setPolicyManagement(true);
      setTalentAquisation(true);
    } else if (selectedRole === "hrRecruiter") {
      setEmployeeRecordAccess(true);
      setOnBoardingAccess(true);
      setEmployeeEditBoarding(true);
      setGoalManagement(true);
      setTalentAquisation(true);
    } else if (selectedRole === "manager") {
      setLeaveApproval(true);
      setNotificationSend(true);
      setHiringReq(true);
    } else if (selectedRole === "facilityTeam") {
      setEquipmentManagement(true);
      setEmployeeDetailsView(true);
      setEmployeeManagement(true);
      setHousekeepingStaffManagement(true);
    } else {
      setOnBoardingAccess(false);
      setLetterGenerate(false);
      setProjectAssign(false);
      setEmployeeRecordAccess(false);
      setEmployeeEditBoarding(false);
      setCompanyManagement(false);
      setSalaryStructureCreation(false);
      setPayslipEditGenerate(false);
      setLeaveManagement(false);
      setNotificationSend(false);
      setEventManagement(false);
      setGoalManagement(false);
      setPolicyManagement(false);
      setLeaveApproval(false);
      setEquipmentManagement(false);
      setEmployeeDetailsView(false);
      setEmployeeManagement(false);
      setHousekeepingStaffManagement(false);
    }
  }, [selectedRole]);

  return (
    <DialogBox
      trigger={<ButtonCompo variant={"contained"}>Add</ButtonCompo>}
      title="Manage Access"
      maxWidth="full"
      fullScreen
      actionButton={
        <ButtonCompo variant={"contained"} onClick={addAdmin}>
          Submit
        </ButtonCompo>
      }
    >
      <div>
        <SelectField
          valueArray={roleArray}
          value={selectedRole}
          label={"Role"}
          setValue={(e) => setSelectedRole(e?.target?.value)}
        />
        <div className="mt-5 w-full">
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Employee Onboarding
            </p>
            <SwitchCompo
              value={onBoardingAccess}
              setValue={(e) => setOnBoardingAccess((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Leave Approval
            </p>
            <SwitchCompo
              value={leaveApproval}
              setValue={(e) => setLeaveApproval((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Letter Generate
            </p>
            <SwitchCompo
              value={letterGenerate}
              setValue={(e) => setLetterGenerate((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Project Assign
            </p>
            <SwitchCompo
              value={projectAssign}
              setValue={(e) => setProjectAssign((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Employee Record Access
            </p>
            <SwitchCompo
              value={employeeRecordAccess}
              setValue={(e) => setEmployeeRecordAccess((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Employee Edit Onboarding
            </p>
            <SwitchCompo
              value={employeeEditBoarding}
              setValue={(e) => setEmployeeEditBoarding((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Company Management
            </p>
            <SwitchCompo
              value={companyManagement}
              setValue={(e) => setCompanyManagement((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Talent Aquisation
            </p>
            <SwitchCompo
              value={talentAquisation}
              setValue={(e) => setTalentAquisation((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Hiring Request
            </p>
            <SwitchCompo
              value={hiringReq}
              setValue={(e) => setHiringReq((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Salary Structure Configurations
            </p>
            <SwitchCompo
              value={salaryStructureCreation}
              setValue={(e) => setSalaryStructureCreation((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Payslip Configurations
            </p>
            <SwitchCompo
              value={payslipEditGenerate}
              setValue={(e) => setPayslipEditGenerate((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Leave Management
            </p>
            <SwitchCompo
              value={leaveManagement}
              setValue={(e) => setLeaveManagement((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Notification Access
            </p>
            <SwitchCompo
              value={notificationSend}
              setValue={(e) => setNotificationSend((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Company Events Management
            </p>
            <SwitchCompo
              value={eventManagement}
              setValue={(e) => setEventManagement((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Employee Details Access
            </p>
            <SwitchCompo
              value={employeeDetailsView}
              setValue={(e) => setEmployeeDetailsView((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Employee Management
            </p>
            <SwitchCompo
              value={employeeManagement}
              setValue={(e) => setEmployeeManagement((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Goal Management
            </p>
            <SwitchCompo
              value={goalManagement}
              setValue={(e) => setGoalManagement((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Policy Management
            </p>
            <SwitchCompo
              value={policyManagement}
              setValue={(e) => setPolicyManagement((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              Equippment Management
            </p>
            <SwitchCompo
              value={equipmentManagement}
              setValue={(e) => setEquipmentManagement((prev) => !prev)}
            />
          </section>
          <section className="flex items-center w-full justify-between border-b-[1px] py-2 hover:bg-slate-200/30 cursor-pointer">
            <p className="text-slate-700 text-[14px] sm:text-[16px]">
              House Keping Staff Management
            </p>
            <SwitchCompo
              value={housekeepingStaffManagement}
              setValue={(e) => setHousekeepingStaffManagement((prev) => !prev)}
            />
          </section>
        </div>
      </div>
    </DialogBox>
  );
}

function AddAdmin() {
  const isSuperadmin = useSelector(
    (state) => state.superadmin?.isSuperadminAuthenticated
  );
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [adminData, setAdminData] = useState([]);
  const [reload, setReload] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isSuperadmin !== undefined && isSuperadmin === false) {
      navigate("/superadmin/signin");
    }
  }, [isSuperadmin]);

  //fetch all employee data
  async function getEmployees() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/employees/all`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setEmployeeData(res.data?.data);
      let rawData = res.data?.data;
      let admins = rawData?.filter((e) => e?.adminId !== undefined);
      setAdminData(admins);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Employees data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //set role of admin
  const [adminRole, setAdminRole] = useState("");

  // delete admin
  async function deleteAdmin(userId) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/admin/delete/${userId}`,
        method: "delete",
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Admin deleted successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // value array of role of select field
  const roleArray = [
    {
      title: "Manager",
      value: "manager",
    },
    {
      title: "HR",
      value: "headHr",
    },
    {
      title: "HR Recruiter",
      value: "hrRecruiter",
    },
    {
      title: "Facility Team",
      value: "facilityTeam",
    },
    {
      title: "IT Helpdesk (System Admin)",
      value: "itHelpDesk",
    },
  ];

  const [selectedTable, setSelectedTable] = useState("emps");

  // array for radio groups
  const radioArray = [
    {
      title: "Employees",
      value: "emps",
    },
    {
      title: "Admins",
      value: "admns",
    },
  ];

  useEffect(() => {
    getEmployees();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center flex-col">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Add Admin
          </h1>
          <div className="w-full mt-5 flex xl:hidden">
            <RadioCompo
              valueArray={radioArray}
              label="Select A Table"
              value={selectedTable}
              onChange={(e) => setSelectedTable(e?.target?.value)}
            />
          </div>
          <div className="mt-5 w-full flex items-start justify-center gap-5">
            <div className="w-full xl:w-[60%] border rounded-[10px] min-h-[13rem] overflow-auto">
              <section className="border-b-[1px] py-3 rounded-t-[10px]">
                <h2 className="px-4 font-semibold text-[20px]">
                  {selectedTable === "emps" ? "Employees" : "Admins"}
                </h2>
              </section>
              {selectedTable === "emps" ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Picture</TableCell>
                      <TableCell className="!text-center">Name</TableCell>
                      <TableCell className="!text-center">Role</TableCell>
                      <TableCell className="!text-center">
                        Phone Number
                      </TableCell>
                      <TableCell className="!text-center">Email ID</TableCell>
                      <TableCell className="!text-right">Admin</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {employeeData?.map((e, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>
                          <div className="w-[3rem] h-[3rem]">
                            <img
                              src={`${SERVER_URL}/api/v1/file/view/${e?.logo}`}
                              className="w-full h-full object-cover rounded-full"
                            />
                          </div>
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.fullName}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.role}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.phoneNumber}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.profEmail}
                        </TableCell>
                        <TableCell className="!text-right">
                          {e?.adminId === undefined ||
                          e?.adminId?.length === 0 ? (
                            <AdminAccessManagement
                              userId={e?._id}
                              setLoading={setLoading}
                              setReload={setReload}
                              setMessage={setMessage}
                              setOpen={setOpen}
                              setSuccess={setSuccess}
                            />
                          ) : (
                            <ButtonCompo
                              onClick={() => deleteAdmin(e?.adminId)}
                              variant={"contained"}
                              color={"error"}
                            >
                              Remove
                            </ButtonCompo>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : adminData?.length > 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Picture</TableCell>
                      <TableCell className="!text-center">Name</TableCell>
                      <TableCell className="!text-center">Role</TableCell>
                      <TableCell className="!text-right">Remove</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {adminData?.map((e, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>
                          <div className="w-[3rem] h-[3rem]">
                            <img
                              src={`${SERVER_URL}/api/v1/file/view/${e?.logo}`}
                              className="w-full object-cover rounded-full"
                            />
                          </div>
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.fullName}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.role}
                        </TableCell>
                        <TableCell className="!text-right">
                          {e?.adminId === undefined ||
                          e?.adminId?.length === 0 ? (
                            <AdminAccessManagement
                              userId={e?._id}
                              setLoading={setLoading}
                              setReload={setReload}
                              setMessage={setMessage}
                              setOpen={setOpen}
                              setSuccess={setSuccess}
                            />
                          ) : (
                            <ButtonCompo
                              onClick={() => deleteAdmin(e?.adminId)}
                              variant={"contained"}
                              color={"error"}
                            >
                              Remove
                            </ButtonCompo>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <h3 className="w-full text-center mt-5 text-[20px] font-medium text-slate-400">
                  No Admins Yet
                </h3>
              )}
            </div>
            <div className="w-[40%] hidden xl:flex flex-col border rounded-[10px] min-h-[13rem] overflow-auto">
              <section className="border-b-[1px] py-3 rounded-t-[10px]">
                <h2 className="px-4 font-semibold text-[20px]">Admins</h2>
              </section>
              {adminData?.length > 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Picture</TableCell>
                      <TableCell className="!text-center">Name</TableCell>
                      <TableCell className="!text-center">Role</TableCell>
                      <TableCell className="!text-right">Remove</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {adminData?.map((e, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>
                          <div className="w-[3rem] h-[3rem]">
                            <img
                              src={`${SERVER_URL}/api/v1/file/view/${e?.logo}`}
                              className="w-full object-cover rounded-full"
                            />
                          </div>
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.fullName}
                        </TableCell>
                        <TableCell className="!text-center">
                          {e?.admin?.role === "headHr"
                            ? "HR"
                            : e?.admin?.role === "hrRecruiter"
                            ? "HR Recruiter"
                            : e?.admin?.role === "itHelpDesk"
                            ? "IT Helpdesk (System Admin)"
                            : e?.admin?.role === "manager"
                            ? "Manager"
                            : "Custom"}
                        </TableCell>
                        <TableCell className="!text-right">
                          {e?.adminId === undefined ||
                          e?.adminId?.length === 0 ? (
                            <DialogBox
                              maxWidth="xs"
                              title="Select A Role"
                              trigger={
                                <ButtonCompo variant={"contained"}>
                                  Add
                                </ButtonCompo>
                              }
                              actionButton={
                                <ButtonCompo onClick={() => addAdmin(e?._id)}>
                                  Add
                                </ButtonCompo>
                              }
                              closeActionButton="cancel"
                            >
                              <SelectField
                                valueArray={roleArray}
                                value={adminRole}
                                label={"Role"}
                                setValue={(e) => setAdminRole(e?.target?.value)}
                              />
                            </DialogBox>
                          ) : (
                            <ButtonCompo
                              onClick={() => deleteAdmin(e?.adminId)}
                              variant={"contained"}
                              color={"error"}
                            >
                              Remove
                            </ButtonCompo>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <h3 className="w-full text-center mt-5 text-[20px] font-medium text-slate-400">
                  No Admins Yet
                </h3>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAdmin;
